/*
 *  Copyright (c) 2011-2023 Acronis Incorporated. All rights reserved.
 *
 *  This source code may be used only by organizations licensed to use Acronis Access, in conjunction with normal Acronis Access usage.
 *  No portion of it may be redistributed or modified without the written permission of Acronis, Inc. See the Acronis Software License Agreement for more information.
 */

'use strict';

angular.module('access.Nodes')
    .factory('ShareGroupsMembersResource', [
        '$resource',
        function (
            $resource
        ) {
            return $resource('/share_groups/:share_group_id/members/:id', {}, {
                save: {
                    method: 'POST',
                    ignoreApiErrors: true,
                    params: {
                        share_group_id: '@uuid'
                    },
                }
            });
        }
    ]);
